import type { AxiosRequestConfig } from 'axios';

import { api } from '~/shared/lib/api';

import { CatalogResponseType } from './getCatalog.schema';

type QueryParams = {
  page?: number;
  size?: number;
  zone?: string;
};

const TEMPORARY_SIZE = 1000;

export const getCatalog = async (
  params: QueryParams = { size: TEMPORARY_SIZE, zone: 'ru' },
  options: AxiosRequestConfig = {},
): Promise<CatalogResponseType['catalog']> => {
  const { zone, ...queryParams } = params;
  const { data: responseData } = await api.get(`/api/v1/${zone}/catalog`, {
    params: queryParams,
    ...options,
  });

  return responseData.catalog;
};
